module.exports = __webpack_public_path__ + "images/df8c470428f1f953a7179da2a85b93dc-romance_xpo.png";